try {
  window.$ = window.jQuery = require('jquery');
} catch(e) {}
